<template>
  <div id="app">
    <van-tabbar v-if="showBar" v-model="active" route style="background: #ffffff">
      <van-tabbar-item replace to="/index" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/message" icon="chat-o" :badge="messageCnt">消息</van-tabbar-item>
      <van-tabbar-item replace to="/my" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
    <router-view/>
  </div>
</template>

<script>
import MyWs from "./utils/ws";
import { mapGetters } from 'vuex'

const showBarPath = ['/index', '/message', '/my']
export default {
  name: 'App',
  data () {
    return {
      active: 1,
      message_num: '',
      showBar: false
    }
  },
  created () {
    this.getUrl()
    this.handleStart()
  },
  watch: {
    '$route' (to, from) {
      if (showBarPath.indexOf(to.path) > -1) {
        this.showBar = true
      } else {
        this.showBar = false
      }
    }
  },
  computed: {
  ...mapGetters([
      'messageCnt'
    ])
  },
  methods: {
    getUrl () {
      if (showBarPath.indexOf(this.$route.path) > -1) {
        console.log('world is greating...')
        this.showBar = true
      } else {
        this.showBar = false
      }
    },
    handleStart () {
      if (localStorage.getItem('token')) {
        this.$store.dispatch('notice/setMessageCnt')
        let Ws = new MyWs('wss://erp-brand.zhian-design.com:1238')
        const handleChat = data => {
          if (data instanceof Object && data.unread_count && data.unread_count > 0) {
            this.message_num = data.unread_count
          }
          if (data && data.message_type === 'create_pdf') {
            localStorage.setItem('download_pdf', JSON.stringify(data.content))
          }
        }
        Ws.subscribe('chat', handleChat)
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  background: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue